import { motion } from 'framer-motion';
import styled from 'styled-components';
import { breakpoints } from 'styles/breakpoints';

export const StyledRollingOffersWrapper = styled(motion.div)<{
  isHorizontalViewEnabled: boolean;
}>`
  margin-top: 5px;
  width: 100%;
  padding: 0 16px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 2;
  box-sizing: border-box;

  & > div {
    width: 100%;
    max-width: 400px;
    ${({ isHorizontalViewEnabled }) =>
      isHorizontalViewEnabled &&
      `
        @media (min-width: ${breakpoints.desktopS}) {
          max-width: 816px;
        }

        @media (min-width: 1264px) {
          max-width: 1232px;
        }
      `}
  }

  & > div:not(:last-child) {
    margin-bottom: 12px;
  }
` as any;

export const StyledRollingOffersUpperWrapper = styled.div`
  margin-right: 16px;
  margin-left: 16px;
  width: 100%;
  display: flex;
  padding: 5px 16px 0 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
